<script setup>

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<section :id="block?.['anchorId']"
  class="cta cta-contained section-mb">
  <div class="container">

    <div class="cta-content"
        :style="`background-color: ${block?.['ctaContent']?.[0]?.backgroundColor};`">
      <div v-html="block?.['ctaContent']?.[0]?.heading?.html" ref="blockRef" class="cta-heading"></div>

      <p v-if="block?.['ctaContent']?.[0]?.description" class="cta-description">
        {{ block?.['ctaContent']?.[0]?.description }}
      </p>

      <div class="cta-button">
        <GlobalsButton
          v-if="block?.['ctaContent']?.[0]?.button?.url && block?.['ctaContent']?.[0]?.button?.title"
          :url="block?.['ctaContent']?.[0]?.button?.url"
          :title="block?.['ctaContent']?.[0]?.button?.title"
          :type="block?.['ctaContent']?.[0]?.buttonSettings?.linkType"
          :size="block?.['ctaContent']?.[0]?.buttonSettings?.linkSize"
          :icon="block?.['ctaContent']?.[0]?.buttonSettings?.linkIcon"
          :popup-enabled="Boolean(block?.['ctaContent']?.[0]?.buttonSettings?.popupEnabled ?? block?.['ctaContent']?.[0]?.popupEnabled)"
          :popup-form-id="block?.['ctaContent']?.[0]?.popupFormId"
        />
      </div>
    </div>

  </div>
</section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.cta.section-mb {
  margin-top: 60px;

  @media (min-width: 1024px) {
    margin-top: 80px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 100px;
  }
}

.cta-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-block: 62px;
  background-color: var(--color-gray-100);

  @media (min-width: 768px) {
    border-radius: 16px;
    padding-block: 56px;
  }

  @media (min-width: 1440px) {
    padding-block: 80px;
  }
}

.cta-heading, .cta-description  {
  max-width: calc(100% - 64px);
}

.cta-heading + .cta-description {
  margin-top: 32px;
}

.cta-heading > :deep(*) {
  font-family: var(--font-family-heading);
  font-size: 40px;
  font-weight: 500;
  line-height: 110%; /* 44px */
  letter-spacing: -0.8px;
  color: var(--color-gray-900);
}

.cta-description {
  line-height: 140%;
  letter-spacing: -0.32px;
  color: #555869;
}

.cta-button {
  margin-top: 32px;
}

.cta-button {
  color: #fff;
}

.cta-heading :deep(.--en) {
  font-family: 'Serrif', sans-serif;;
}

@media (max-width: 767px) {
  .container {
    padding-inline: 0;
  }
}

@media (max-width: 767px) {
  .cta.section-mb {
    margin-bottom: 0;
  }
}

@media (min-width: 768px) {

  .cta-heading + .cta-description {
    margin-top: 24px;
  }

  .cta-heading :deep(*) {
    font-size: 48px;
    line-height: 120%; /* 57.6px */
    letter-spacing: -0.96px;
    margin-inline: auto;
    /* max-width: 940px; */
  }

  .cta-description {
    font-size: 20px;
    letter-spacing: -.5px;
  }

}

</style>

<style>

.page.--has-background-color .cta-contained .cta-content {
  background-color: var(--color-white);
}

.cta.cta-contained + section {
  margin-top: 80px;

  @media (min-width: 1024px) {
    margin-top: 100px;
  }

  @media (min-width: 1440px) {
    margin-top: 140px;
  }
}

</style>